import { create } from 'zustand';
import type { Model } from '../types';

interface ModelState {
  models: Model[];
  selectedModel: Model | null;
  isLoading: boolean;
  error: string | null;
  setModels: (models: Model[]) => void;
  addModel: (model: Model) => void;
  removeModel: (id: string) => void;
  selectModel: (model: Model | null) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
}

export const useModelStore = create<ModelState>((set) => ({
  models: [],
  selectedModel: null,
  isLoading: false,
  error: null,
  setModels: (models) => set({ models }),
  addModel: (model) => set((state) => ({ models: [model, ...state.models] })),
  removeModel: (id) => set((state) => ({ models: state.models.filter((m) => m.id !== id) })),
  selectModel: (model) => set({ selectedModel: model }),
  setLoading: (isLoading) => set({ isLoading }),
  setError: (error) => set({ error }),
}));
